import { apiDelete, apiGet, apiPost, apiPut } from './api-service';
import { getUserDetails } from './session-service';

const path = 'form-allocation';

export async function addFormAllocation(newDetails: any) {
    const response = await apiPost('core', `${path}`, newDetails);
    return response?.content;
}

export async function updateFormAllocation(newDetails: any, id: string) {
    const response = await apiPut('core', `${path}/${id}`, newDetails);
    return response?.content;
}

export async function removeFormAllocation(id: any) {
    return await apiDelete('core', `${path}/${id}`);
}